import { config } from 'src/config';
import { i18n } from 'src/i18n';
import { NavigationService } from 'src/services/navigation-service';

interface Breadcrumb {
  text: string;
  path: string;
}

interface Breadcrumbs {
  externalBreadcrumbs: Breadcrumb[];
  internalBreadcrumbs: Breadcrumb[];
}

class BreadcrumbUtils {
  public static getBreadcrumbs = (path: string): Breadcrumbs => ({
    externalBreadcrumbs: [
      {
        text: i18n.component.breadcrumbs.mainPage,
        path: config.ALTIBOX_MY_PAGES_URL,
      },
    ],
    internalBreadcrumbs: BreadcrumbUtils.getInternalBreadcrumbs(path),
  });

  public static getInternalBreadcrumbs = (path: string): Breadcrumb[] => {
    const breadcrumbs = [
      {
        path: NavigationService.STORE,
        text: i18n.component.breadcrumbs.productSelectPage,
      },
      {
        path: NavigationService.PRODUCT_DETAILS,
        text: i18n.component.breadcrumbs.productDetailsPage,
      },
      {
        path: NavigationService.SUMMARY,
        text: i18n.component.breadcrumbs.summaryPage,
      },
    ];

    const currentBreadcrumbIndex = breadcrumbs.findIndex((element) => element.path === path);

    return breadcrumbs.slice(0, currentBreadcrumbIndex + 1);
  };

  public static isFirstInternalBreadcrumb = (path: string): boolean => {
    const internalBreadCrumb = BreadcrumbUtils.getInternalBreadcrumbs(path);

    return internalBreadCrumb.length !== 0 && internalBreadCrumb[0].path === path;
  };
}

export { BreadcrumbUtils };
